'use client';
import { createBareContext } from '@s7/react-utils';

var _createBareContext = createBareContext();
var CheckboxGroupProvider = _createBareContext[0], useCheckboxGroupContext = _createBareContext[1];

export { CheckboxGroupProvider, useCheckboxGroupContext };
